// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"3195":"7f39d1212b8afd02","6648":"1966285586f9cdb1"}[chunkId] + ".css";
};